import { HistoryEvent } from "./tactics.model";
import { Round } from "./player.model";
export class ShanghaiPlayer {
    constructor(name, rounds) {
        this.totalScore = 0;
        this.rounds = [];
        this.name = name;
        this.rounds = [];
        rounds.forEach(round => {
            this.rounds.push(new Round(parseInt(round), 0, null));
        });
    }
}
export class ShanghaiHistoryEvent extends HistoryEvent {
    constructor(type, playerIndex, segment, pointsAdded, previousTotal) {
        super(type, playerIndex, segment);
        this.pointsAdded = pointsAdded;
        this.previousTotal = previousTotal;
    }
}
